import { useState } from 'react'
import { db } from '../../../firebase'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'

import StudentsList from './StudentsList'
import './studentsAdmin.css'

export default function StudentsAdmin() {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [role, setRole] = useState('student')
  const [active, setActive] = useState(true)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setMessage('')

    try {
      await addDoc(collection(db, 'users'), {
        email: email.trim(),
        name: name.trim(),
        role,
        active,
        createdAt: serverTimestamp(),
      })

      setMessage(`Пользователь ${name} успешно добавлен`)
      setEmail('')
      setName('')
      setRole('student')
      setActive(true)
    } catch (error) {
      console.error(error)
      setMessage(`Ошибка: ${error.message}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="students-admin-container">
      <div className="add-user-form">
        <h2>Добавить пользователя</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Имя"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="student">Студент</option>
            <option value="admin">Админ</option>
          </select>

          <label>
            Активен
            <input type="checkbox" checked={active} onChange={(e) => setActive(e.target.checked)} />
          </label>

          <button type="submit" disabled={loading}>
            {loading ? 'Добавляем...' : 'Добавить пользователя'}
          </button>
        </form>

        {message && <p>{message}</p>}
      </div>

      <StudentsList />
    </div>
  )
}
